/**
 * Author: Roman Liubinets
 * Created at 08/20/2019
 * https://marvelapp.com/43fgc52/screen/56949300
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Pagination from '@components/@core/Pagination';
import Button from '@components/@core/AnimatedButton';
import Quota from './ListCard';

const List = (props) => {
    const { data, role, onChange, onPer, onAddQuota } = props;
    const quotas = data?.data ?? [];

    return (
        <div className="lib-todo-quota px-0" data-cy="quota-list">
            <div className="d-none d-sm-flex py-2">
                <div className="d-flex-4 dsl-m12">Goal</div>
                <div className="d-flex-1 ps-5 dsl-m12">Type</div>
                <div className="d-flex-1 dsl-m12">Scorecards</div>
                <div className="d-flex-1 dsl-m12">Health Plans</div>
                <div className="d-flex-1 dsl-m12">Certifications</div>
                <div className="d-flex-1 dsl-m12">Assigned</div>
            </div>

            {quotas.length > 0 ? (
                quotas.map((quota) => (
                    <Quota
                        role={role}
                        key={quota.id}
                        name={quota.name}
                        data={quota.data}
                        type={quota.quota_value}
                        published={quota.published}
                        onToggle={() => props.onToggle(quota.id)}
                        onChange={(e) => props.onSelect(e, quota)}
                    />
                ))
            ) : (
                <p>No Quotas available to display.</p>
            )}
            <div className="d-flex mt-2 jc-end">
                <Button type="high" onClick={onAddQuota}>
                    Add Goal
                </Button>
            </div>
            <Pagination current={data?.current_page} per={Number(data?.per_page)} pers={[10, 25, 50, 'all']} total={data?.last_page} onChange={onChange} onPer={onPer} />
        </div>
    );
};

List.propTypes = {
    role: PropTypes.number,
    data: PropTypes.shape({
        current_page: PropTypes.number,
        data: PropTypes.array,
        last_page: PropTypes.number,
    }),
    onChange: PropTypes.func,
    onToggle: PropTypes.func,
    onModal: PropTypes.func,
};

List.defaultProps = {
    role: 1,
    data: {
        current_page: 0,
        data: [],
        last_page: 0,
    },
    onChange: () => {},
    onToggle: () => {},
    onModal: () => {},
};

export default memo(List);
